import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        name: 'Login',
        path: '/login',
        component: () => import('@src/views/Login/index'),
        meta: { title: '登录', whiteList: true },
    },
    {
        name: 'Index',
        path: '/',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore index.vue has no declaration file
        component: () => import('@src/views/Index/index.vue'),
        meta: { title: '首页' },
    },
    {
        name: 'Forbidden',
        path: '/forbidden',
        component: () => import('@src/views/Forbidden/index'),
        meta: { whiteList: true },
    },
    {
        path: '/:catchAll(.*)',
        redirect: { path: '/forbidden' },
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});
